<template>
  <div class="upload-videos">
    <v-dialog persistent v-model="dialog" content-class="video-upload-dialog">
      <div
        class="video-upload-dialog-container"
        @dragenter.prevent="dragEnter"
        @dragleave.prevent="dragLeave"
        @dragover.prevent
        @drop.prevent
      >
        <v-form @submit.prevent ref="videoUploadRef">
          <v-text-field
            v-model="campaignName"
            class="video-upload-input"
            outlined
            placeholder="Your campaign name here.."
            :rules="appliedRules"
          >
          </v-text-field>

          <hr
            style="
              border: 0.5px solid #e3e3e3;
              background-color: #e3e3e3;
              color: #e3e3e3;
            "
          />

          <div class="mid-section flex">
            <div class="left-portion">
              <v-menu
                :nudge-bottom="description == '' ? 10 : 60"
                bottom
                :close-on-content-click="false"
                :value="openMenu"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-textarea
                    v-model="description"
                    class="create-content-input"
                    height="100"
                    v-on="openMenu ? on : ''"
                    v-bind="attrs"
                    outlined
                    maxlength="500"
                    placeholder="What is this post about? Start writing here. Now add #tag with post..."
                    counter=""
                    :rules="appliedRules"
                    ref="descriptionFieldRef"
                    v-on:keyup="keymonitor"
                  >
                  </v-textarea>
                </template>
                <div
                  class="mt-0 hastag_div"
                  style="z-index: 2; overflow: hidden; width: 100%"
                >
                  <div style="height: 180px" class="v-list_custom">
                    <v-list style="height: 20px" v-if="items.length >= 1">
                      <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        @click="addHashtagToDescription(item)"
                      >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <div v-else>
                      <div>
                        <div class="flex">
                          <p>Please type to get result</p>
                        </div>
                        <div v-if="isLoading">
                          <v-spacer />
                          <v-progress-linear
                            indeterminate
                            color="green"
                          ></v-progress-linear>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-menu>
              <p>Select Orientation <span style="color: red">*</span></p>
              <v-radio-group
                class="grid_tile"
                v-model="radioGroup"
                column
                style="display: flex; marhon-top: 8px"
              >
                <div style="display: flex; align-items: baseline">
                  <v-radio value="portrait" label="Portrait"> </v-radio>
                  <v-radio
                    style="margin-left: 20px"
                    value="landscape"
                    label="Landscape"
                  >
                  </v-radio>
                </div>
              </v-radio-group>
              <div class="upload">
                <input
                  type="file"
                  id="vertical-video-uploader"
                  style="display: none"
                  @change="selectVideo"
                  accept="video/*"
                />
                <div class="flex upload">
                  <label
                    for="vertical-video-uploader"
                    class="flex upload-video --blue pointer"
                    style="background-color: #f8f5f9; color: #9a5acb"
                  >
                    <img
                      src="@/assets/MainDashboard/CreateContent/VideoUploadIcon.svg"
                      alt=""
                    />
                    Upload from your computer
                  </label>
                </div>

                <v-progress-linear
                  v-if="videoUploadingProcess"
                  :value="videoUploadingProcess"
                  color="#9A5ACB"
                  height="25"
                  striped
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>
                <div class="upload mt-2">
                  <label
                    @click="checkButtonActionAndAct"
                    class="flex upload-video --green pointer"
                    style="background-color: rgba(87, 215, 192, 0.05)"
                  >
                    <img
                      src="@/assets/MainDashboard/CreateContent/link.svg"
                      alt=""
                    />
                    {{ formData.formName }}
                    <v-icon
                      v-if="formData.ID"
                      @click.native="checkButtonActionAndAct"
                      class="remove-form mx-2"
                    >
                      mdi-close
                    </v-icon>
                  </label>
                </div>
                <div class="flex drop-zone" @drop.prevent="dropImages">
                  <p>Or drag and drop your files here</p>
                </div>
              </div>
            </div>
            <div class="right-portion flex" v-if="!videoPreview">
              Video Preview
            </div>

            <div class="right-portion flex" v-if="videoPreview">
              <video
                id="vertical-video-preview"
                autoplay
                muted
                :src="videoPreview"
                style="width: 100%"
              ></video>
            </div>
          </div>

          <div class="buttons-section flex">
            <button class="close" @click="$emit('close')">
              <v-icon color="#8749B6">mdi-close</v-icon>
            </button>
            <button
              class="--green draft"
              v-ripple
              @click.prevent="checkTypeActionAndAct(true)"
            >
              Save as a draft
            </button>
            <button
              class="publish white--text bold"
              v-ripple
              @click.prevent="checkTypeActionAndAct(false)"
            >
              PUBLISH POST
            </button>
          </div>
          <v-progress-linear
            indeterminate
            class="mt-2"
            color="#9A5ACB"
            v-if="loader"
          ></v-progress-linear>
        </v-form>
      </div>
    </v-dialog>
    <lead-form-list
      :dialog="leadFormList"
      ref="leadFormListRef"
      @close="leadFormList = false"
    />
  </div>
</template>

<script>
import accessToken from "../../../../helpers/accessToken";
import API_URL from "../../../../helpers/apiUrls";
import rules from "../../../../helpers/rules";
import { uuid } from "vue-uuid";
import helper from "../../../../helpers/methods";
import leadFormList from "./lead-form-list.vue";
import { eventBus } from "../../../../main";
import MoengageEventGenerator from "../../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../../helpers/moengageEvents";
import MoengageAttributes from "../../../../helpers/moengageAttributes";
import getCurrent  from "../../../../helpers/methods";
export default {
  name: "uploadVideoModal",

  data() {
    return {
      campaignName: "",
      description: "",
      videoFileName: "",
      temporaryVideoPreview: null,
      videoPreview: null,
      rules: rules,
      appliedRules: [],
      uploadConfigs: {},
      videoID: null,
      bucketName: "",
      expiryTime: null,
      bucketPath: null,
      maxVideoDuration: null,
      videoSize: null,
      eTags: [],
      uploadID: null,
      keyName: null,
      parts: 0,
      imageThumbnail: null,
      loader: false,
      videoUploadingProcess: 0,
      uuid: uuid.v1(),
      leadFormList: false,
      videoIDForEdit: "",
      isLoading: false,
      hashtagQuery: "",
      selectedHastags: [],
      deleteListner: false,
      hashtagQueryDec: false,
      items: [],
      openMenu: false,
      ishashDetected: false,
      lastHashtag: "",
      hashdetectInMiddle: false,
      ref: null,
      currentLength: 0,
      lastposition: 0,
      hashtagStringDescription: "",
      radioGroup: null,
    };
  },

  computed: {
    formData() {
      return this.$store.getters["createContentStore/GET_SELECTED_FORM"];
    },
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
    },
  },

  watch: {
    dialog: function (value) {
      if (!value) {
        this.campaignName = "";
        this.description = "";
        this.loader = false;
        this.videoUploadingProcess = 0;
        this.videoPreview = null;
        this.$refs.videoUploadRef.reset();
        this.$store.commit("createContentStore/REMOVE_SELECTED_FORM");
        this.$router.go();
      }
    },
    eTags: function (val) {
      console.log("eTags", val);
    },
    entityId: function (val) {
      console.log("item", val);
    },
    hashtagQuery: function (val) {
      console.log("hashtaggQueryWatcher", val);
    },
    description: function (val) {},
    ishashDetected: function () {},

    openMenu: function (val) {
      console.log("openMenu", val);
      this.hashtagQuery = "";
      this.items = [];
      this.$refs.descriptionFieldRef.focus();
    },
    radioGroup: function (val) {
      console.log("radioGroup", val);
    },
  },

  mounted() {
    eventBus.$on("formSelected", (data = null) => {
      this.leadFormList = false;

      if (data === "refresh") {
        this.$emit("refreshList");
        this.showToast("The form has been successfully attached!");
      }
    });

    eventBus.$on("openFormList", (ID) => {
      this.$store.state.createContentStore.selectedForm.postType = "clips";
      this.openLeadFormList();
    });
  },

  methods: {
    selectVideo(event) {
      if (this.radioGroup==null) {
        this.showToast("Please select Orientation");
        event.stopPropagation()
       
      } else {
        const size = (event.target.files[0].size / (1024 * 1024)).toFixed(2);
        const actualSize = helper.getFormatedSizeofVideoinMb(size);
        //console.log('size',size,actualSize,this.uploadConfigs.max_video_size_in_mb);
        if (
          parseFloat(
            this.uploadConfigs.max_video_size_in_mb
              ? this.uploadConfigs.max_video_size_in_mb
              : 35
          ) < size
        ) {
          this.showToast(
            "Video size should not be greater than 35 Mb",
            "error",
            2000
          );
          return;
        } else {
          this.videoFileName = event.target.files[0].name;
          this.temporaryVideoPreview = URL.createObjectURL(
            event.target.files[0]
          );
          this.videoPreview = this.temporaryVideoPreview;
          this.videoSize = size;
          const videoChunks = helper.createVideoChunks(
            event.target.files[0],
            10,
            actualSize
          );
          this.getPresignedURLs(event, videoChunks);
        }
      }
    },

    dragEnter() {
      this.isDragged = true;
    },
    dragLeave() {
      this.isDragged = false;
    },

    dropImages(event) {
      const newEvent = {
        target: {
          files: [event.dataTransfer.files[0]],
        },
      };
      this.selectVideo(newEvent);
    },

    getPresignedURLs(event, videoChunks) {
      this.videoUploadingProcess = 0;
      const successHandler = (response) => {
        if (response.status === 200) {
          this.uploadVideo(response.data.url_list, videoChunks);
          this.uploadID = response.data.upload_id;
          this.keyName = response.data.key_name;
          this.parts = response.data.parts;
          this.videoUploadingProcess += 1;
          setTimeout(() => {
            this.videoUploadingProcess += 24;
          }, 500);
        }
      };

      const errorHandler = (error) => {
        this.showToast(
          "Something went wrong internally, aborting video upload...",
          "error",
          10000
        );
        console.log(error);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      this.uploadConfigs.file_format = `.${
        event.target.files[0].type.split("/")[1]
      }`;

      this.uploadConfigs.size_in_mb = this.videoSize;
      console.log(this.videoSize);

      this.requestGET(
        API_URL.createContent__getVideoPresignedURLs,
        this.uploadConfigs,
        headers,
        successHandler,
        errorHandler
      );
    },

    uploadVideo(urls, videoChunks) {
      urls.forEach((url, index) => {
        const successHandler = (response) => {
          if (response.status === 200) {
            this.eTags.push({
              ETag: response.headers.etag,
              PartNumber: url.part_no,
            });
            if (urls.length - 1 === index) this.informS3AboutVideoUpload();
          }
        };

        const errorHandler = (error) => {
          this.showToast(
            "Something went wrong internally, aborting video upload...",
            "error",
            10000
          );
          console.log(error);
          this.abortVideoUploadRequest();
          return;
        };

        // const data = new FormData();
        // data.append('file', videoChunks[index]);
        const file = videoChunks[index];

        this.requestPUT(url.url, file, {}, successHandler, errorHandler);
      });
    },

    // this will be called one time only after getting the etags array
    informS3AboutVideoUpload() {
      this.videoUploadingProcess += 25;
      const successHandler = (response) => {
        if (response.status === 200) {
          this.registerVideoInBackend(response.data.Key);
          this.videoUploadingProcess += 25;
        }
      };

      const errorHandler = (error) => {
        console.log(error);
        this.showToast(
          "Something went wrong internally, aborting video upload...",
          "error",
          10000
        );
        this.abortVideoUploadRequest();
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      const data = {
        bucket_name: this.bucketName,
        upload_id: this.uploadID,
        key_name: this.keyName,
        parts: this.lodash.sortBy(this.eTags, "PartNumber"),
      };

      this.requestPOST(
        API_URL.createContent__uploadComplete,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },

    registerVideoInBackend(key) {
      const successHandler = (response) => {
        if (response.status === 201) {
          this.videoID = response.data.id;
          this.showToast("The video has been successfully uploaded!");
          this.videoUploadingProcess += 25;
          this.videoPreview = this.temporaryVideoPreview;
          this.eTags = [];
        }
      };

      const errorHandler = (error) => {
        console.log(error);
        this.showToast(
          "Something went wrong internally, aborting video upload...",
          "error",
          10000
        );
        this.abortVideoUploadRequest();
      };

      var video = document.getElementById("vertical-video-preview");
      console.log("vertical-video-preview", video);
      this.imageThumbnail = helper.generateVideoThumbnail(
        video,
        this.videoFileName
      );

      const data = new FormData();
      const videoID = key.split(".")[0];
      /* This is should be ideally generated in backend */
      data.append("video_id", videoID);
      data.append("video_path", key);
      data.append("orientation", this.radioGroup);
      data.append("image", this.imageThumbnail);

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      this.requestPOST(
        API_URL.createContent__registerVideo,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },

    checkTypeActionAndAct(isDraft) {
      this.generateHashTagDescriptionWithTags();
      if (this.type === "edit") this.editVideoPost(isDraft);
      else this.createVideoPost(isDraft);
    },

    createVideoPost(isDraft) {
      this.appliedRules.push(this.rules.required);
      if (this.$refs.videoUploadRef.validate()) {
        this.loader = true;
        const successHandler = (response) => {
          if (response.status) {
            const moengageAttr = {
            [MoengageAttributes.IsUserGenerated]: "TRUE",
            [MoengageAttributes.BrandName]: localStorage.getItem("Brand-Name"),
            [MoengageAttributes.BrandId]: localStorage.getItem("Brand-ID"),
            [MoengageAttributes.DateofContentCreation]: getCurrent.getCurrentDate(),
            [MoengageAttributes.TimeofContentCreation]: getCurrent.getCurrentTime(),
            [MoengageAttributes.contentType]: "clip",
          };
          MoengageEventGenerator(
            MoengageEvents.BusinessContentCreated,
            moengageAttr
          );
            this.$emit("refreshList");
            this.$emit("close");
            this.$refs.videoUploadRef.reset();
            this.loader = false;
            if (this.formData.ID) this.attachFormWithPost(response.data.id);
          }
        };

        const errorHandler = (error) => {
          console.log(error);
          this.showToast("Something went wrong internally!", "error", 10000);
          this.loader = false;
        };

        const headers = {
          Authorization: `Bearer ${accessToken.getAccessToken()}`,
          "BRAND-ID": localStorage.getItem("Brand-ID"),
        };

        const data = {
          campaign_name: this.campaignName,
          is_draft: isDraft,
          description: this.hashtagStringDescription,
          video: this.videoID,
        };

        this.requestPOST(
          this.$store.getters["mainStore/GET_SUPER_ADMIN"]
            ? API_URL.createContent__videoUpload_Admin
            : API_URL.createContent__videoUpload,
          data,
          headers,
          successHandler,
          errorHandler
        );
      }
    },

    editVideoPost(isDraft) {
      this.appliedRules.push(this.rules.required);

      if (this.$refs.videoUploadRef.validate()) {
        this.loader = true;
        const successHandler = (response) => {
          if (response.status) {
            this.$emit("refreshList");
            this.$emit("close");
            this.$refs.videoUploadRef.reset();
            this.loader = false;
            if (this.formData.ID) this.attachFormWithPost(response.data.id);
          }
        };

        const errorHandler = (error) => {
          console.log(error);
          this.showToast("Something went wrong internally!", "error", 10000);
          this.loader = false;
        };

        const headers = {
          Authorization: `Bearer ${accessToken.getAccessToken()}`,
          "BRAND-ID": localStorage.getItem("Brand-ID"),
        };

        const data = {
          campaign_name: this.campaignName,
          is_draft: isDraft,
          description: this.hashtagStringDescription,
          video: this.videoID,
        };

        this.requestPOST(
          this.$store.getters["mainStore/GET_SUPER_ADMIN"]
            ? `${API_URL.createContent__updateOrDelete_Admin}${this.videoIDForEdit}/krishi_clip_update`
            : `${API_URL.createContent__updateOrDelete}${this.videoIDForEdit}/krishi_clip_update`,
          data,
          headers,
          successHandler,
          errorHandler
        );
      }
    },

    attachFormWithPost(postID) {
      const data = {
        form: this.formData.ID,
        post_id: postID,
        post_type: "clips",
      };
      this.$store.dispatch("createContentStore/attachFormWithPost", data);
    },

    checkButtonActionAndAct(event) {
      if (event.target.className.includes("remove-form")) {
        this.$store.commit("createContentStore/REMOVE_SELECTED_FORM");
      } else this.openLeadFormList();
    },

    openLeadFormList() {
      this.leadFormList = true;
      this.$refs.leadFormListRef.getFormList();
    },

    abortVideoUploadRequest() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.videoUploadingProcess = 0;
          this.temporaryVideoPreview = null;
          this.videoPreview = null;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      const data = {
        bucket_name: this.bucketName,
        upload_id: this.uploadID,
        key_name: this.keyName,
      };

      this.requestPOST(
        API_URL.createContent__abortVideoUpload,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },
    hashtagEntityServiceApiCall(query) {
      this.isLoading = true;
      console.log("query", query);
      const successHandler = (response) => {
        if (response.status === 200) {
          this.isLoading = false;
          this.items = response.data.results;
          console.log("searchitems", this.searchitems);
        }
      };

      const errorHandler = (error) => {
        if (error.response.status === 404) {
          console.log(error);
        } else {
          this.showToast("Something went wrong internally!", "error", 10000);
        }

        console.log(error);
        this.isLoading = false;
      };

      this.requestGET(
        `${API_URL.hashtag_service}?q=${query.replace("#", "")}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_ENTITY_SEARCH_PROD
      );
    },
    addHashtagToDescription(item) {
      //this.selectedHastags.push(item);
      this.genearteListofHashTagUsed(item);
      this.lastHashtag = item.title;
      // if(this.hashtagQuery!='')
      //console.log('hashtagQueryE',this.hashtagQuery);
      console.log("description ", this.description);
      console.log("hashtagQuery", this.hashtagQuery);
      console.log("title", item.title);
      if (
        this.description.includes(item.title) &&
        this.currentLength > 0 &&
        this.description.length > this.currentLength
      ) {
        this.description =
          this.description.slice(0, this.currentLength) +
          " " +
          item.title +
          " " +
          this.description.slice(this.currentLength);
        this.description = this.description.replace(
          " #" + this.hashtagQuery + " ",
          ""
        );

        console.log("item Enc ====>e0");
        this.openMenu = false;
        this.hashtagQuery = "";
        this.ishashDetected = false;
        //this.currentLength=0;
        return;
      }

      if (this.description.includes(item.title) && this.hashtagQuery == "") {
        console.log("string detectedE");
        this.description = this.description + " " + item.title;
        this.description = this.description.replace(" # ", "");
        this.description = this.description.replace("## ", "#");

        this.ishashDetected = false;
        this.openMenu = false;
        console.log("==============>0");
      } else if (this.description.includes(item.title)) {
        if (this.lastHashtag == item.title) {
          console.log("lasthastag", this.hashtagQuery, this.description);
          this.description += " " + item.title;
          this.description = this.description.replace(
            "#" + this.hashtagQuery + " ",
            ""
          );
        } else {
          console.log("string detected");
          this.description = this.description + " " + item.title;
          this.description = this.description.replace(
            "#" + this.hashtagQuery,
            ""
          );
          this.description = this.description.replace(" # ", "");
          this.description = this.description.replace("## ", "#");

          this.ishashDetected = false;
          this.openMenu = false;
          console.log("==============>1");
        }
      } else {
        // if (this.currentLength > 0) {
        //     console.log("position detected", this.currentLength,this.hashtagQuery);
        //    // this.description=this.description.slice(0, this.currentLength) + item.title + this.description.slice(this.currentLength)
        //     this.openMenu = false;
        //     this.hashtagQuery = "";
        //     this.ishashDetected = false;
        //     return;
        // }
        if (this.lastHashtag == item.title) {
          if (
            this.currentLength < this.description.length &&
            this.currentLength > 0
          ) {
            console.log(
              "position detected",
              this.currentLength,
              this.hashtagQuery,
              this.description.indexOf(" #" + this.hashtagQuery)
            );
            this.description =
              this.description.slice(0, this.currentLength) +
              " " +
              item.title +
              " " +
              this.description.slice(this.currentLength);
            this.description = this.description.replace(
              " #" + this.hashtagQuery + " ",
              ""
            );
            this.openMenu = false;
            this.hashtagQuery = "";
            this.ishashDetected = false;
            this.currentLength = 0;
            console.log("==============>2.0");
            return;
          } else {
            console.log("lasthastag", this.hashtagQuery, this.description);
            this.description += " " + item.title;
            this.description = this.description.replace(
              "#" + this.hashtagQuery + " ",
              ""
            );
            this.openMenu = false;
            this.hashtagQuery = "";
            this.ishashDetected = false;
            console.log("==============>2");
            this.currentLength = 0;
            return;
          }
        }

        if (item.title.includes(this.hashtagQuery)) {
          console.log("=== title match with hashtag");
          this.description = this.description.replace(
            "#" + this.hashtagQuery,
            ""
          );
          this.description = this.description + " " + item.title;
          console.log("==============>2.1");
        } else {
          if (this.lastHashtag == item.title) {
            console.log("lasthastag", this.hashtagQuery, this.description);
            this.description += " " + item.title;
            this.description = this.description.replace(
              "#" + this.hashtagQuery + " ",
              ""
            );
            this.openMenu = false;
            this.hashtagQuery = "";
            this.ishashDetected = false;
            console.log("==============>3", this.currentLength);
            return;
          }
          this.hashtagQuery = this.hashtagQuery.replace(
            "#" + this.hashtagQuery,
            item.title
          );
          this.description = this.description.replace(
            "#" + this.hashtagQuery,
            ""
          );

          this.description = this.description + item.title;
          this.description = this.description.replace(
            "#" + this.hashtagQuery,
            ""
          );
          this.description = this.description.replace(" # ", "");
          this.description = this.description.replace("## ", "#");
          console.log("==============>3.1");
        }
      }

      console.log("hashtagQueryAfterReplace", this.hashtagQuery);

      //this.description+=item.title
      // this.description = this.description + item.title;
      // this.description = this.description.replace("##", "#");
      // this.description = this.description.replace("#"+item.tile+"#"+item.tile, "#"+item.tile);

      console.log(
        "HashTag",
        item,
        this.menu,
        this.selectedHastags,
        this.description,
        this.hashtagQuery
      );
      // console.log('this.hashtagQuery', this.hashtagQuery);
      // this.description=this.description.replace('#'+this.hashtagQuery,'')
      this.openMenu = false;
      this.hashtagQuery = "";
      this.ishashDetected = false;
      // this.description=hashTagData;
    },
    findHashtags(searchText) {
      let test = searchText.search("#नवीनतम कृषि तकनीक");
      let result = this.description.replace("#नवीनतम कृषि तकनीक", "W3Schools");
      console.log(test, result);
      var tagListArray = [];
      var regexp = new RegExp(" (#\\w+)\\b", "g");
      var tmplist = this.description.match(regexp);
      for (var w in tmplist) {
        var hashSub = tmplist[w].split("#");
        for (var x in hashSub) {
          if (hashSub[x] != "") {
            if (hashSub[x].substr(hashSub[x].length - 1) == ":") {
              hashSub[x] = hashSub[x].slice(0, -1);
            }
            if (hashSub[x] != "") {
              tagListArray.push(hashSub[x]);
            }
          }
        }
      }
      console.log("tagListArray", tagListArray);
    },

    generateNewHashTag(item) {
      let obj = {
        has_data: false,
        id: item,
        sub_title: "",
        title: "#" + item,
        type: "text",
      };
      this.genearteListofHashTagUsed(obj);
      //this.selectedHastags.push(obj);
      //    const hashtag = this.description + "#" + this.hashtagQuery;
      //    this.description = hashtag.replace("##", "#");
      //    this.description = this.hashtagQuery.replace("##", "#");
      this.ishashDetected = false;
      this.hashtagQuery = "";
      this.currentLength = 0;
      this.openMenu = false;
      console.log("generateNewHashTag", this.selectedHastags);
    },

    keymonitor(event) {
      console.log("event.key", event.key);

      const last = this.description.charAt(this.description.length - 1);

      console.log(last);

      if (event.key == "Backspace") {
        //this.hashtagQuery = "";
        const newQuery = this.hashtagQuery.slice(
          0,
          this.hashtagQuery.length - 1
        );
        this.hashtagQuery = newQuery;

        console.log("dec==>");

        this.hashtagEntityServiceApiCall(this.hashtagQuery);
        if (this.hashtagQuery == "") {
          this.openMenu = false;
          this.ishashDetected = false;
          console.log("dec==> #  space");
        } else if (last == "#") {
          console.log("dec==> #");
          this.ishashDetected = false;
          if (!this.ishashDetected) {
            this.openMenu = false;
          } else {
            this.openMenu = true;
          }
        }
      }
      if (last == "#" && !this.ishashDetected) {
        this.ishashDetected = true;

        this.openMenu = true;
        console.log("0");
      } else if (event.key == "Backspace" && last == "#") {
        this.ishashDetected = false;
        this.hashtagQuery = "";
        this.openMenu = false;
        console.log("1");
      } else if (event.key == "Backspace" && this.ishashDetected) {
        //const last = this.hashtagQuery.slice(0,this.hashtagQuery.length-1)+this.hashtagQuery.slice(this.hashtagQuery.length+1);
        //str.slice(0,index) + str.slice(index+1)
        //his.hashtagQuery= this.hashtagQuery.substr(0, this.hashtagQuery.length - 1)

        //this.hashtagQuery=this.description;
        console.log("bk", this.description, this.hashtagQuery, last);
        this.hashtagEntityServiceApiCall(this.hashtagQuery);
        console.log("2");
      } else {
        if (
          this.ishashDetected &&
          ((event.keyCode >= 65 && event.keyCode <= 90) ||
            (event.keyCode >= 97 && event.keyCode <= 112) ||
            event.key == "_" ||
            event.key == "-" ||
            event.key == "#")
        ) {
          this.hashtagQuery += event.key;
          this.hashtagEntityServiceApiCall(this.hashtagQuery);
          console.log("3", this.currentLength);
          this.items = [];
        }
        if (event.key == "#") {
          this.ishashDetected = true;
          //this.hashtagQuery = "";
          this.openMenu = true;
          this.currentLength = this.description.indexOf(" # ");
          console.log("#keyMid", this.currentLength);
        } else if (event.key == " ") {
          //this.currentLength = this.description.indexOf(" # ");
          //this.hashtagQuery=this.hashtagQuery.replace(this.hashtagQuery,'#'+this.hashtagQuery);
          this.generateNewHashTag(this.hashtagQuery);
          console.log(
            "spacebar#newhastag#keyMid",
            this.currentLength,
            this.hashtagQuery
          );
          console.log(
            "spacebar#newhastag#keyMiddesc",

            this.description
          );
        } else if (event.key == " ") {
          this.currentLength = this.description.indexOf(" # ");
          console.log("spacebar#keyMid", this.currentLength);
        } else if (event.key == "ArrowLeft") {
          this.currentLength = this.description.indexOf(" # ");
          console.log("ArrowLeft#keyMid", this.currentLength);
        }
      }
    },
    genearteListofHashTagUsed(hashString) {
      let isdetected = false;
      if (hashString.title == "#") {
        console.log("hashretuen");
        return;
      }
      console.log("hashString", hashString);
      if (this.selectedHastags.length == 0) {
        this.selectedHastags.push(hashString);
      }
      if (this.selectedHastags.length > 0) {
        this.selectedHastags.map((item) => {
          console.log("item", item);
          if (item.title === hashString.title && item.id === hashString.id) {
            isdetected = true;
            console.log("find");
          }
        });
      }
      if (!isdetected) {
        this.selectedHastags.push(hashString);
        console.log("pushed");
      }
      console.log("selectedHastags", this.selectedHastags);
    },
    generateHashTagDescriptionWithTags() {
      let hashtagString = this.description;

      let descWithoutSelectedHAshtag = this.description;
      this.selectedHastags.map((item) => {
        if (descWithoutSelectedHAshtag.includes(item.title)) {
          let regex = new RegExp("(\\W|^)" + item.title + "(\\W|$)", "g");
          descWithoutSelectedHAshtag = descWithoutSelectedHAshtag.replaceAll(
            regex,
            ""
          );
        }
      });
      let splitDesc = descWithoutSelectedHAshtag.split(" ");
      console.log("splitDesc=====>", splitDesc, descWithoutSelectedHAshtag);

      splitDesc.map((item) => {
        if (!item.charAt(0) == "#") {
          console.log("item.includes#", item);
          let index = splitDesc.indexOf(item);
          if (index) {
            splitDesc.splice(index, 1);
            console.log("item.includes# Removed", item);
          }
        }
      });
      console.log("splitDesc=====>After", splitDesc);

      // this.selectedHastags.map((item) => {
      //      let index = splitDesc.indexOf(item.title);

      //      console.log('com===>',splitDesc[index],item.title,item.title==splitDesc[index]);
      //      if(item.title==splitDesc[index]){
      //         splitDesc=  splitDesc.splice(index, 1);
      //           console.log('splitDesc.splice(index, 1);',splitDesc.splice(index, 1))
      //      }

      // });
      let temp = [];
      this.selectedHastags.map((item) => {
        temp.push(item.title);
      });

      splitDesc = splitDesc.filter((val) => !temp.includes(val));

      console.log("splitDesc=====>0", splitDesc);

      splitDesc.map((item) => {
        console.log("item.includes(#)", !item.includes("#"), item);
        if (!item.includes("#")) {
          let index = splitDesc.indexOf(item);
          splitDesc.splice(index, 1);
        }
      });

      console.log("selectedHastags@", this.selectedHastags);
      console.log("splitDesc@", splitDesc);

      this.selectedHastags.map((item) => {
        console.log("generateHashTagDescriptionWithTags", item);
        let regex = new RegExp("(\\W|^)" + item.title + "(\\W|$)", "g");
        //   const indexes = [];

        //     for (let index = 0; index < hashtagString.length; index++) {
        //         if (str[index] === 'l') {
        //             indexes.push(index);
        //         }
        //     }
        console.log(
          "searchRegExp",
          regex,
          item.title,
          hashtagString.matchAll(regex),
          hashtagString
        );
        hashtagString = hashtagString.replace(
          regex,
          ` <hashtag id=${item.id}, type=${item.type}>${item.title}</hashtag> `
        );
      });
      splitDesc.map((item) => {
        if (item.charAt(0) == "#") {
          let regex = new RegExp("(\\W|^)" + item + "(\\W|$)", "g");
          console.log(
            "searchRegExp==>",
            regex,
            item,
            hashtagString.match(regex),
            hashtagString
          );
          hashtagString = hashtagString.replace(
            regex,
            ` <hashtag id=${item.slice(
              1,
              item.length
            )}, type=text>${item}</hashtag> `
          );
          console.log("Remove splice", item.slice(1, item.length));
        }
      });
      console.log("generateHashTagDescription", hashtagString);
      this.hashtagStringDescription = hashtagString;
    },
  },

  components: {
    "lead-form-list": leadFormList,
  },
};
</script>

<style lang="scss" scoped>
.video-upload-dialog-container {
  background-color: white;
  font-family: Roboto;
  padding: 20px;
}

hr {
  margin-top: -10px;
}

.mid-section {
  justify-content: space-between;
  align-items: stretch;
}

.left-portion {
  width: 68%;
}

.upload label {
  border-radius: 5px;
  padding: 13px;
  font-size: 0.9rem;
  width: 100%;
}

.upload label img {
  margin-right: 15px;
}

.drop-zone {
  flex-direction: column;
  background: #fbfdfc;
  border: 1px dashed #dbdbdb;
  border-radius: 7px;
  margin: 20px 0;
  padding: 60px 0;
  color: #c2cbc3;
  position: relative;

  p {
    margin: 0;
  }
}

.right-portion {
  width: 30%;
  background: #fbfdfc;
  border: 1px dashed #dbdbdb;
  box-sizing: border-box;
  border-radius: 7px;
  margin: 10px 0 20px 0;
  color: #c2cbc3;
}

.buttons-section {
  justify-content: space-between;
}

button {
  border-radius: 5px;
  font-size: 1rem;
  padding: 20px 0;
}

.close {
  width: 10%;
}

.close,
.draft {
  background: rgba(115, 49, 138, 0.05);
}

.draft,
.publish {
  width: 44%;
}

.draft {
  background: rgba(115, 49, 138, 0.05);
  color: #9a5acb;
}

.publish {
  background: #9a5acb;
  box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
}
.hastag_div {
  background-color: white;
  width: 300px;
}
.v-list_custom {
  overflow-y: scroll;
}
@media all and (min-width: 1400px) {
  .upload label {
    font-size: 1rem;
  }
}
</style>

<style lang="scss">
.video-upload-dialog.v-dialog {
  width: 60%;
}

.video-upload-input fieldset {
  color: white !important;
}

@media all and (min-width: 1500px) {
  .video-upload-dialog.v-dialog {
    width: 50%;
  }
}
</style>
